import React from "react";
import styled from "styled-components";
import { Modal, Row, Col, Card, Button } from "antd";
import { CustomLabel } from "../../../../Common/style";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import PAGE_CONSTANTS from "../constant";
import { BookVisitDetails } from "../../CommonData";
import "./appointmentModal.css";

const OkButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 180px;
  height: 50px;
  border-radius: 40px;
  border: solid 0.5px #f26221;
  margin-top: 10px;
  text-align: center;
  background-image: ${(props) =>
    props.disable ? "" : "linear-gradient(to top, #f26221, #f5851f)"};
  .ant-btn-text[disabled] {
    color: #f26221 !important;
    font-weight: bold;
  }
  .ant-btn-text {
    color: white !important;
    font-weight: bold;
  }
  &:hover {
    background-image: linear-gradient(to top, #f26221, #f5851f);
    .ant-btn-text[disabled] {
      color: white !important;
      font-weight: bold;
    }
  }
  @media (max-width: 768px) {
    width: 110px;
    height: 35px;
    border-radius: 17.5px;
    padding: 12px 2px;
    .ant-btn-text[disabled] {
      font-size: 11px;
    }
    .ant-btn-text {
      font-size: 11px;
    }
  }
`;

const RaisedModal = ({ open, memberName, memberId, onClose }) => {
  const { [memberId]: bookState } = BookVisitDetails();
  const { visitType } = bookState || {}
  const isDcType = visitType === PAGE_CONSTANTS?.DIAGNOSTIC_CENTER_TYPE;

  return (
    <Modal
      style={{ top: 20 }}
      open={open}
      onCancel={onClose}
      closable={false}
      destroyOnClose
      zIndex="999"
      footer={null}
    >
      <div className="modal-wrapper">
        <Card>
          <Row>
            <Col md={24} className="title">
              <CustomLabel font_size="24" font_weight="bold">
                {`Great! ${memberName}, your appointment requests have been raised.`}
              </CustomLabel>
            </Col>
            <Col md={24} className="subtitle-raised">
              <CustomLabel font_size="16" font_weight="normal">
                {`We shall get back to you as soon as the appointment is confirmed. ${isDcType ? 'Don’t forget to carry the following documents while visiting the Diagnostic Centre.' : ''}`}
              </CustomLabel>
            </Col>
          </Row>
          <Row gutter={[10, 0]}>
            <Col xs={24} md={12}>
              <Row>
                <div className="orange-icon-circle">
                  <span style={{ fontSize: "17px", color: "white" }}>
                    <i className="fa fa-envelope" aria-hidden="true"></i>
                  </span>
                </div>
                <Col xs={24}>
                  <CustomLabel font_size="14" font_weight="bold">
                    {"Email"}
                  </CustomLabel>
                </Col>
                <Col xs={24} className="xs-mb-6 description">
                  <CustomLabel font_size="14" font_weight="normal">
                    {
                      "Communication will be sent on your email id and SMS."
                    }
                  </CustomLabel>
                </Col>
              </Row>
            </Col>
            <Col xs={24} md={12}>
              <Row>
                <div className="orange-icon-circle">
                  <span style={{ fontSize: "24px", color: "white" }}>
                    <i className="fa fa-user" aria-hidden="true"></i>
                  </span>
                </div>
                <Col xs={24}>
                  <CustomLabel font_size="14" font_weight="bold">
                    {"Photo ID"}
                  </CustomLabel>
                </Col>
                <Col xs={24} className="description">
                  <CustomLabel font_size="14" font_weight="normal">
                    {`Pan Card/Driving license/Voter ID Card/Passport/Employee ID ${isDcType ? '& submit the copy to DC with self attestation.' : ''}`}
                  </CustomLabel>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className="modal-btn-wrapper">
            <Col xs={24}>
              <div className="justify-flex-center">
                <OkButton disable={false}>
                  <Button onClick={onClose} type="text" disabled={false}>
                    {"OK, I GOT IT"}
                    <FontAwesomeIcon
                      icon={faAngleRight}
                      className="right-icon"
                    />
                  </Button>
                </OkButton>
              </div>
            </Col>
          </Row>
        </Card>
      </div>
    </Modal>
  );
};

export default RaisedModal;
